import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFlaskIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.11 17.49 15 8.73V4h1a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2h1v4.73l-5.11 8.76a3.0002 3.0002 0 0 0 1.0883 4.1058A3 3 0 0 0 6.48 22h11a2.9998 2.9998 0 0 0 2.59-4.51h.04Zm-9.25-8A.9993.9993 0 0 0 11 9V4h2v5c.0019.176.0501.3486.14.5L14 11h-4l.86-1.51Zm7.52 10a.9994.9994 0 0 1-.86.5h-11a1.0007 1.0007 0 0 1-.86-.5 1.0001 1.0001 0 0 1 0-1L8.83 13h6.35l3.2 5.5a.9997.9997 0 0 1 0 1v-.01ZM10 15a.9998.9998 0 0 0-.707 1.7071.9998.9998 0 0 0 1.5385-.1515A1 1 0 0 0 10 15Zm4 1a.9994.9994 0 0 0-.9239.6173 1.0002 1.0002 0 0 0 1.7554.9383A1 1 0 0 0 14 16Z"/>
  </SvgIcon>
}

export default LineFlaskIcon
